/**
 * User: Lior Elrom
 * Date: 4/12/16
 * Time: 5:47 PM
 */

'use strict';

const _ = require('underscore');
const React = require('react');
const classNames = require('classnames');
const { URL } = require('bunsen/helpers/uri.es');
const User = require('bunsen/models/identity/User');
const chatUtils = require('../../global/utils/social/chat.es');
const storage = require('../helpers/checkout-storage.es');
const trackEvent = require('../helpers/checkout-track-event.es');
const surveyCopy = require('../copy/checkoutSurvey');
const styles = require('../../../scss/checkout/subviews/_checkout-survey.scss');

// components
const { Modal, Header } = require('../../global/views/modal/index');
const DibsRadioButtonInput = require('../../global/components/DibsRadioButtonInput');

const getUserId = () => {
    const loggedIn = User.loggedIn();
    return loggedIn ? User.getCurrentUser().id : "Not logged in";
};

class CheckoutSurvey extends React.Component {

    constructor(props) {
        super(props);
        this.onRadioClick = this.onRadioClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            isOpened: true,
            isDisabled: false,
            selected: '',
            additionalInfo: ''
        };
    }

    componentWillMount() {
        this.radioOptions = _.shuffle(surveyCopy.radioOptions);
    }

    componentDidMount() {
        storage.setHasSeenSurvey();
        trackEvent.triggerCheckoutSurveyDisplayed();
    }

    onRadioClick(value) {
        this.setState({ selected: value });
    }

    closeModal() {
        this.setState({ isOpened: false });
    }

    onChange(event) {
        this.setState({additionalInfo: event.target.value});
    }

    onSubmit() {
        const {selected: reason, additionalInfo} = this.state;
        trackEvent.triggerCheckoutSurveySubmitted();
        chatUtils.track.checkoutSurveySubmitted({reason, additionalInfo});
        this.setState({ isDisabled: true });
    }

    getRadioOptions() {
        const shuffledOptions = this.radioOptions;
        const RadioOptions = shuffledOptions.map(option => this.renderRadio(option));
        RadioOptions.push(this.renderRadio('Other'));
        return RadioOptions;
    }

    renderRadio(value) {
        const { selected } = this.state;
        const isSelected = selected === value;
        const radioDataTag = value.replace(/\s/g, '-').replace('.', '').toLowerCase();

        return (
            <DibsRadioButtonInput
                inputId={value}
                name="reason"
                value={value}
                title={value}
                titleClass={styles.labelClass}
                labelDataTn={radioDataTag}
                isSelected={isSelected}
                onSelect={this.onRadioClick.bind(this, value)}
                key={value}
            />
        );
    }

    render() {
        const { selected, isOpened, isDisabled } = this.state;
        const surveyInfo = storage.getSurveyInfo();
        const { itemId, orderType } = surveyInfo;
        const radioOptions = this.getRadioOptions();
        const baseDataTn = 'checkout-survey';

        const textareaContainerClass = classNames(
            {
                [styles.desktopHidden]: !selected
            }
        );
        const buttonClass = classNames(
            'button-large',
            'button-primary',
            'mobile-full-width', {
                'disabled': isDisabled
            }
        );

        return (
            <Modal modalClass={styles.container} dataTn={baseDataTn} isOpened={isOpened} closeModal={this.closeModal}>
                <Header>
                    <span className={styles.modalHeader} data-tn={`${baseDataTn}-header`}>{surveyCopy.title}</span>
                </Header>
                    <form
                        id="tfa_0"
                        method="post"
                        action="https://www.tfaforms.com/responses/processor"
                        data-tn={`${baseDataTn}-form`}
                        ref="form"
                        onSubmit={this.onSubmit}
                        className={styles.formClass}
                    >
                        {radioOptions}
                        <div className={textareaContainerClass}>
                            <p className={styles.textAreaLabel}>{surveyCopy.textAreaLabel}</p>
                            <textarea
                                className={styles.textarea}
                                name="tfa_6"
                                maxLength="1000"
                                placeholder={surveyCopy.placeholder}
                                data-tn={`${baseDataTn}-text-input`}
                                onChange={this.onChange}
                            />
                            <div className={styles.buttonWrapper}>
                                <button type="submit" className={buttonClass} disabled={isDisabled} data-tn={`${baseDataTn}-submit`}>{surveyCopy.submit}</button>
                            </div>
                        </div>

                        <input type="hidden" id="tfa_9" name="tfa_9" value={navigator.userAgent} />
                        <input type="hidden" id="tfa_8" name="tfa_8" value={getUserId()} />
                        <input type="hidden" id="tfa_10" name="tfa_10" value={itemId} />
                        <input type="hidden" id="tfa_11" name="tfa_11" value={orderType} />
                        <input type="hidden" id="tfa_13" name="tfa_13" value={URL.source} />
                        <input type="hidden" id="tfa_12" name="tfa_12" value={selected} />

                        <input type="hidden" id="tfa_dbFormId" name="tfa_dbFormId" value="413075" />
                        <input type="hidden" id="tfa_dbControl" name="tfa_dbControl" value="c6cdf45727af0ab1bbf30b6ec6c49e33" />
                        <input type="hidden" id="tfa_dbVersionId" name="tfa_dbVersionId" value="5" />
                        <input type="hidden" id="tfa_switchedoff" name="tfa_switchedoff" value="" />
                        <input type="hidden" id="tfa_dbResponseId" name="tfa_dbResponseId" value="" />
                    </form>
            </Modal>
        );
    }
}

module.exports = CheckoutSurvey;



// WEBPACK FOOTER //
// ./assets/js/checkout/containers/CheckoutSurvey.jsx